import { useState, useEffect } from "react";
import {
    GetOtherProfileStories
} from "../../services/api";
import StoryViewer from "../../components/Profile/StoryViewer";
import { MdOutlineVideoLibrary } from "react-icons/md";
import { getMediaUrl } from "../../utils/helpers";

export function OtherStory({ userId }) {

    const [localClips, setLocalClips] = useState([]);
    const [openStory, setOpenStory] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        fetchStories();
    }, []);

    const fetchStories = () => {
        GetOtherProfileStories(userId)
            .then(res => {
                setLocalClips(Array.isArray(res.data) ? res.data : []);
            })
            .catch(console.error);
    };

    return (
        <div className="w-full">

            {/* HEADER */}
            <div className="flex gap-2 items-center text-lg font-bold mt-10">
                <MdOutlineVideoLibrary size={30} />
                Clips {localClips.length}
            </div>

            {/* SCROLL ROW */}
            <div className="flex overflow-x-auto no-scrollbar gap-4 py-10">

                {/* CLIPS */}
                {localClips.map((clip, index) => (
                    <div
                        key={clip._id || clip.id}
                        onClick={() => {
                            setActiveIndex(index);
                            setOpenStory(true);
                        }}
                        className="relative w-[90px] h-[90px] rounded-full
                        border-4 border-red-500 overflow-hidden shrink-0 cursor-pointer"
                    >
                        <video
                            src={getMediaUrl(clip.url)}
                            className="w-full h-full object-cover"
                            muted
                            preload="metadata"
                        />
                    </div>
                ))}
            </div>

            {/* STORY VIEWER */}
            {openStory && (
                <StoryViewer
                    stories={localClips}
                    startIndex={activeIndex}
                    onClose={() => setOpenStory(false)}
                    showMenuOption={false}
                />
            )}
        </div>
    );
}